var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoisW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_736_84)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 4.5,
    width: 35,
    height: 35,
    rx: 5.5,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 1.8125V7.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 1.8125V7.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.404785 14.875H37.192",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6496 29.625V23.271H8.6576L11.1596 27.168H10.6466L13.1396 23.271H14.1566V29.625H12.7436V25.656L12.9956 25.719L11.3666 28.257H10.4306L8.8106 25.719L9.0536 25.656V29.625H7.6496ZM18.4082 29.733C17.9282 29.733 17.4842 29.649 17.0762 29.481C16.6742 29.313 16.3202 29.079 16.0142 28.779C15.7082 28.479 15.4712 28.131 15.3032 27.735C15.1352 27.333 15.0512 26.901 15.0512 26.439C15.0512 25.971 15.1352 25.539 15.3032 25.143C15.4712 24.747 15.7052 24.402 16.0052 24.108C16.3052 23.808 16.6562 23.577 17.0582 23.415C17.4662 23.247 17.9102 23.163 18.3902 23.163C18.8642 23.163 19.3022 23.247 19.7042 23.415C20.1122 23.577 20.4662 23.808 20.7662 24.108C21.0722 24.402 21.3092 24.75 21.4772 25.152C21.6452 25.548 21.7292 25.98 21.7292 26.448C21.7292 26.91 21.6452 27.342 21.4772 27.744C21.3092 28.14 21.0752 28.488 20.7752 28.788C20.4752 29.082 20.1212 29.313 19.7132 29.481C19.3112 29.649 18.8762 29.733 18.4082 29.733ZM18.3902 28.446C18.7682 28.446 19.0982 28.362 19.3802 28.194C19.6682 28.026 19.8902 27.792 20.0462 27.492C20.2022 27.186 20.2802 26.835 20.2802 26.439C20.2802 26.139 20.2352 25.869 20.1452 25.629C20.0552 25.383 19.9262 25.173 19.7582 24.999C19.5902 24.819 19.3892 24.684 19.1552 24.594C18.9272 24.498 18.6722 24.45 18.3902 24.45C18.0122 24.45 17.6792 24.534 17.3912 24.702C17.1092 24.864 16.8902 25.095 16.7342 25.395C16.5782 25.689 16.5002 26.037 16.5002 26.439C16.5002 26.739 16.5452 27.012 16.6352 27.258C16.7252 27.504 16.8512 27.717 17.0132 27.897C17.1812 28.071 17.3822 28.206 17.6162 28.302C17.8502 28.398 18.1082 28.446 18.3902 28.446ZM22.6262 29.625V23.271H24.0392V29.625H22.6262ZM27.0478 29.724C26.5258 29.724 26.0758 29.64 25.6978 29.472C25.3258 29.298 24.9838 29.037 24.6718 28.689L25.5898 27.78C25.7938 28.014 26.0188 28.197 26.2648 28.329C26.5168 28.455 26.8078 28.518 27.1378 28.518C27.4378 28.518 27.6688 28.464 27.8308 28.356C27.9988 28.248 28.0828 28.098 28.0828 27.906C28.0828 27.732 28.0288 27.591 27.9208 27.483C27.8128 27.375 27.6688 27.282 27.4888 27.204C27.3148 27.126 27.1198 27.051 26.9038 26.979C26.6938 26.907 26.4838 26.826 26.2738 26.736C26.0638 26.64 25.8688 26.523 25.6888 26.385C25.5148 26.241 25.3738 26.064 25.2658 25.854C25.1578 25.638 25.1038 25.368 25.1038 25.044C25.1038 24.654 25.1968 24.318 25.3828 24.036C25.5748 23.754 25.8388 23.541 26.1748 23.397C26.5108 23.247 26.8978 23.172 27.3358 23.172C27.7798 23.172 28.1848 23.25 28.5508 23.406C28.9228 23.562 29.2288 23.775 29.4688 24.045L28.5508 24.954C28.3588 24.756 28.1638 24.609 27.9658 24.513C27.7738 24.417 27.5548 24.369 27.3088 24.369C27.0628 24.369 26.8678 24.417 26.7238 24.513C26.5798 24.603 26.5078 24.735 26.5078 24.909C26.5078 25.071 26.5618 25.203 26.6698 25.305C26.7778 25.401 26.9188 25.485 27.0928 25.557C27.2728 25.629 27.4678 25.701 27.6778 25.773C27.8938 25.845 28.1068 25.929 28.3168 26.025C28.5268 26.121 28.7188 26.244 28.8928 26.394C29.0728 26.538 29.2168 26.724 29.3248 26.952C29.4328 27.174 29.4868 27.45 29.4868 27.78C29.4868 28.386 29.2708 28.863 28.8388 29.211C28.4068 29.553 27.8098 29.724 27.0478 29.724Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_736_84",
    x: -4,
    y: -3.1875,
    width: 46,
    height: 48.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_736_84"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_736_84",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoisW);
export default __webpack_public_path__ + "static/media/moisW.a7ee2a645ce1b5de092ab56c05bc35ff.svg";
export { ForwardRef as ReactComponent };